<template>
  <el-dialog title="土壤墒情条件控制" :visible.sync="show" width="60%">
    <div style="height: 360px">
      <el-alert type="success" :closable="false">
        闷棚（土壤处理）期，地表温度保持在40℃以上。土壤湿度没有具体量化要求。
        基于模型的自动控制请至“综合营养”板块查看
      </el-alert>
      <el-row class="mt-3">
        <el-col span="6">
          <h5>实时土壤温度</h5>
          <p>45.1 <span class="font-size:12px">℃</span></p>

          <h5>实时土壤湿度</h5>
          <p>23.5 <span class="font-size:12px">%RH</span></p>

        </el-col>
        <el-col span="6">
          <h5>土壤温度建议范围</h5>
          <p>--</p>

          <h5>土壤湿度建议范围</h5>
          <p>--</p>

        </el-col>
        <el-col span="12">
          <h5>建议</h5>
          <p>建议地表温度保持在40℃以上，此阶段没有智能控制建议。</p>

          <h5>灌溉控制</h5>
          <p>
            <el-button-group>
              <el-button type="primary" :disabled="true" size="small">
                关闭
              </el-button>
              <el-button type="primary" :disabled="true" size="small">
                自动
              </el-button>
              <el-button type="primary" :disabled="true" size="small">
                打开
              </el-button>
            </el-button-group>
          </p>

          <h5>通风控制</h5>
          <p>
            <el-button-group>
              <el-button type="primary" :disabled="true" size="small">
                关闭
              </el-button>
              <el-button type="primary" :disabled="true" size="small">
                自动
              </el-button>
              <el-button type="primary" :disabled="true" size="small">
                打开
              </el-button>
            </el-button-group>
          </p>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      show: false,
    }
  },
  methods: {
    open() {
      this.show = true
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/welcome/LandGuideSoilDialog.vue